import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Paper, Typography } from '@material-ui/core';
import Box from '@mui/material/Box';
import * as Yup from 'yup';
import { doLogin, getPhoneNumber, resetValue } from '../Login/actionLogin';
import OtpForm from './OtpForm';
import useTimer from '../../../../Hook/useTimer';
import { useHistory } from 'react-router';
import { getMobileNo } from '../../../../utils/localStorage';
import LogoNew from '../../../../utils/assests/logo-new.png';
import otpIcon from '../../../../utils/assests/otp-icon.png';
import ErrorMessage from '../../../../Common/ErrorMessage';
import { logFirebaseEvent } from '../../firebase';
import {
  P2P_OTP_BTN,
  P2P_OTP_VIEW,
  P2P_RESEND_OTP_BTN,
} from '../../firebase/constant';

const VerifyOtp = () => {
  const dispatch = useDispatch();
  const formikRef: any = useRef();
  const { seconds, setSeconds } = useTimer(30);
  const history = useHistory();
  const {
    loginLoader,
    loginError,
    portFolioData,
    errorPortFolio,
    ckycData,
    loginStatus,
    loginData,
  } = useSelector((state: any) => state.login);

  useEffect(() => {
    document.title = 'stashearn - verify-otp';
  }, []);

  useEffect(() => {
    logFirebaseEvent(P2P_OTP_VIEW);
  }, []);

  useEffect(() => {
    if (loginStatus) {
      dispatch(resetValue());
      if (loginData?.results?.landing_page === 1) {
        history.push('/p2p/personalInfo');
      } else if (loginData?.results?.landing_page === 2) {
        history.push('/p2p/connectBank');
      } else if (
        loginData?.results?.landing_page === 4 ||
        loginData?.results?.landing_page === 3
      ) {
        history.push('/p2p/lenderAgreement');
      } else if (loginData?.results?.landing_page === 5) {
        history.push('/p2p/dashboard');
      }
    }
  }, [loginStatus, loginData]);

  const initialValues = {
    phone: getMobileNo(),
    otp_1: '',
    otp_2: '',
    otp_3: '',
    otp_4: '',
  };

  const validationSchema = () =>
    Yup.object().shape({
      otp_1: Yup.string()
        .required('*Required')
        .max(1, 'Please enter a valid otp')
        .min(1, 'Please enter a valid otp'),
      otp_2: Yup.string()
        .required('*Required')
        .max(1, 'Please enter a valid otp')
        .min(1, 'Please enter a valid otp'),
      otp_3: Yup.string()
        .required('*Required')
        .max(1, 'Please enter a valid otp')
        .min(1, 'Please enter a valid otp'),
      otp_4: Yup.string()
        .required('*Required')
        .max(1, 'Please enter a valid otp')
        .min(1, 'Please enter a valid otp'),
    });

  const onSubmitHandle = (value: any) => {
    logFirebaseEvent(P2P_OTP_BTN);
    value.otp = '';
    Object.keys(value).map((inputkey: any) => {
      if (
        inputkey === 'otp_1' ||
        inputkey === 'otp_2' ||
        inputkey === 'otp_3' ||
        inputkey === 'otp_4'
      )
        value.otp += value[inputkey];
    });
    dispatch(doLogin(value));
  };

  const onChangeOtp = () => {
    if (loginError) return dispatch(resetValue());
  };

  const resendOTP = () => {
    logFirebaseEvent(P2P_RESEND_OTP_BTN);
    const phone = getMobileNo();
    if (!phone || seconds > 0) return false;
    const data = {
      phone,
    };
    dispatch(getPhoneNumber(data));
    setSeconds(30);
  };

  const focusChange = (e: any) => {
    if (
      e.target.value.length >= e.target.getAttribute('maxlength') &&
      e.target.nextElementSibling
    )
      e.target.nextElementSibling.focus();

    if (e.keyCode && e.keyCode === 8 && e.target.previousElementSibling)
      e.target.previousElementSibling.focus();
  };

  const checkError = (errors: any) => {
    if (Object.values(errors).length > 0)
      return <ErrorMessage text='*Required' />;
  };

  const backRoute = () => {
    history.goBack();
  };

  const enterKeyPress = (e: any) => {
    if (e.key === 'Enter') {
      if (formikRef?.current?.isValid) {
        onSubmitHandle(formikRef.current.values);
      }
    }
  };

  return (
    /* <Box className='shortHeader'>
          <Box
            sx={{
              mb: '28px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
            }}
          >
            <img src={stashearnLogo} alt='' />
          </Box>
          <Typography variant='h6'>
            enter OTP sent to your mobile no.
          </Typography>
          <Typography>we sent it to the no. {getMobileNo()}</Typography>
        </Box> */

    <Box
      className='contentArea column-fluid loginScreen text-center mt-0 radius-0 no-shadow'
      sx={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}
    >
      <Box className='headingBox'>
        <Box className='otpBox'>
          <Typography variant='h2'>
            Enter your OTP
            <span>Get.Set.Earn</span>
          </Typography>
        </Box>
        <img className='loginIcon' src={otpIcon} alt='' />
      </Box>
      <OtpForm
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmitHandle={onSubmitHandle}
        onChangeOtp={onChangeOtp}
        loginLoader={loginLoader}
        loginError={loginError}
        seconds={seconds}
        setSeconds={setSeconds}
        resendOTP={resendOTP}
        focusChange={focusChange}
        checkError={checkError}
        formikRef={formikRef}
        enterKeyPress={enterKeyPress}
      />
      <Box className='splashBottomLogo'>
        <img src={LogoNew} alt='' />
      </Box>
    </Box>
  );
};

export default VerifyOtp;
